import React, { ComponentProps } from 'react';

import { Popover } from '@draft-js-plugins/mention';
import PropTypes from 'prop-types';

import { stylePropType } from '@adsk/alloy-react-helpers';
import { MenuList } from '@adsk/alloy-react-menu';
import Overlay from '@adsk/alloy-react-overlay';

export type MentionPopoverProps = ComponentProps<typeof Popover> &
  ComponentProps<typeof Overlay.Container>;

const MentionPopover = ({
  className,
  style,
  children,
  ...props
}: MentionPopoverProps) => (
  <Popover {...props}>
    <Overlay.Container
      className={className}
      variant={Overlay.VARIANTS.LIGHT}
      style={[
        {
          position: 'static',
          width: 317,
          maxHeight: 350,
          overflow: 'auto',
        },
        style,
      ]}
    >
      <MenuList style={{ padding: '4px 0' }}>{children}</MenuList>
    </Overlay.Container>
  </Popover>
);

MentionPopover.displayName = 'MentionPopover';

MentionPopover.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
};

export default MentionPopover;
